"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const partnerLogos = [];
  const navigationLinks = [{
    label: "Our Care",
    to: "#"
  }, {
    label: "Our Homes",
    to: "#"
  }, {
    label: "Our Team",
    to: "#"
  }, {
    label: "Referrals",
    to: "#"
  }, {
    label: "Careers",
    to: "#"
  }, {
    label: "Contact Us",
    to: "#"
  }];
  return <footer ref={ref} className={`w-full bg-primary py-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="flex flex-wrap items-center justify-center gap-8 mb-12">
          {partnerLogos.map((logo, i) => <div key={i} data-index={i} className="flex items-center">
              <img src={logo.src} alt={logo.name} className="h-12 w-auto object-contain filter brightness-0 invert" />
            </div>)}
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {}
          <div>
            
          </div>

          {}
          <div>
            <ul className="space-y-3">
              {navigationLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-white text-sm hover:underline transition-all duration-[var(--duration-fast)]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <div className="text-white text-sm space-y-2">
              <p>Thrive Supported Living Services Limited, 5</p>
              <p>
                <Link to="tel:(123) 456-7890" className="hover:underline transition-all duration-[var(--duration-fast)]">
                  (123) 456-7890
                </Link>
              </p>
              <p>
                <Link to="mailto:info@thrive-supportedliving.co.uk" className="hover:underline transition-all duration-[var(--duration-fast)]">
                  info@thrive-supportedliving.co.uk
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}